import { cn } from "@/lib/utils";

export function FilterChipSkeleton({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "h-9 w-20 shrink-0 animate-pulse rounded-full bg-gray-200",
        className
      )}
    />
  );
}

/** Longer chip skeletons that grow to fill the rest of the filter bar. */
export function FilterBarTagsSkeleton({ count = 5 }: { count?: number }) {
  const widths = ["min-w-28", "min-w-36", "min-w-24", "min-w-32", "min-w-40"];

  return (
    <div className="flex min-h-9 min-w-0 flex-1 items-center gap-2 md:gap-3">
      {Array.from({ length: count }).map((_, index) => (
        <FilterChipSkeleton
          key={index}
          className={cn(
            "flex-1",
            widths[index % widths.length],
            index === count - 1 && "min-w-48 flex-[2]"
          )}
        />
      ))}
    </div>
  );
}
